var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplaceDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Replace_Device"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Replace_Device",
    "data-name": "Replace Device",
    clipPath: "url(#clip-Replace_Device)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    transform: "translate(6 8)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 5,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    transform: "translate(18 17)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 5,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Reply",
    d: "M346.987,695.037s2.357,1.822,4.819,3.519c-2.724,2.1-4.819,3.4-4.819,3.4l.012-2.365c-4.869-.029-6.81-2.687-5.717-5.958.834,2.564.927,3.624,5.7,3.849l.006-2.415Z",
    transform: "translate(-334.806 -677.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Reply-2",
    "data-name": "Reply",
    d: "M6,1.4S8.358,3.221,10.82,4.919C8.1,7.017,6,8.32,6,8.32l.012-2.364C1.144,5.927-.8,3.27.3,0c.834,2.564.928,3.623,5.7,3.848L6,1.434Z",
    transform: "translate(23.41 15.32) rotate(180)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceDevice);
export default __webpack_public_path__ + "static/media/ReplaceDevice.f309096916bbde1f58218a1dc0988b15.svg";
export { ForwardRef as ReactComponent };